import * as React from "react";
import HrefLang from "@shared/head/HrefLang";

const Canonical = (props) => {
  return (
    <>
      <link rel="canonical" href={props.url} />
    </>
  );
};

export default Canonical;
